import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Failed } from "assets/icons/failed.svg";
import { ReactComponent as Success } from "assets/icons/success.svg";

const BankActivation = ({ isFailed, message }) => {
  const { t } = useTranslation();

  const renderStatus = () => {
    if (isFailed)
      return [
        "card-page.bank-failed-title",
        "card-page.bank-failed-description",
      ];

    return [
      "card-page.bank-success-title",
      "card-page.bank-success-description",
    ];
  };

  const [title /* description */] = renderStatus();
  const text = isFailed ? "text-error-0" : "text-primary-0";

  return (
    <div>
      <div className="w-28 h-28 table m-auto mb-8 mt-12">
        <div className="w-28 h-28 relative flex justify-center items-center">
          {isFailed ? (
            <Failed className="w-28 h-28 " />
          ) : (
            <Success className="w-28 h-28 " />
          )}
        </div>
      </div>
      <div className={`text-center ${text} h-18px-medium mb-2`}>
        {message || t(title)}
      </div>
      <div className="text-center text-gray-0 body-14px-regular font-normal">
        {/* {t(description)} */}
      </div>
    </div>
  );
};

export default BankActivation;
